GP.views.ThreadsListItem = Backbone.Marionette.ItemView.extend({
    template: function(serialized_data) {
        if (serialized_data.thread.msg_id == 1) {
            // notify user when the message will expire
            return template('thread-expire-upgrade', serialized_data);
        } else if (serialized_data.thread.msg_id == null){
            // when there is no messages show different template without any results
            return template('thread-no-result');
        } else {
            return template('inbox-thread', serialized_data);
        }
    },
    className: 'thread-item-wrap',
    events: {
        'click':                'open_thread',
        'click .checkbox-wrap': 'del_thread_toggle',
        'click .expire-upgrade-thread': 'billing_redirect'
    },
    initialize:function(opts) {
        this.listenTo(GP.vent, 'ThreadList:show_checkboxes', this.show_checkboxes, this);
        this.listenTo(GP.vent, 'ThreadList:show_checkboxes_unread', this.show_checkboxes_unread, this);
        this.listenTo(GP.vent, 'ThreadList:show_checkboxes_read', this.show_checkboxes_read, this);
        this.listenTo(GP.vent, 'ThreadList:show_checkboxes_all', this.show_checkboxes_all, this);
        this.listenTo(GP.vent, 'ThreadList:hide_checkboxes', this.hide_checkboxes, this);

        // copy user for use in template
        if (parseInt(this.model.get('my_duid'), 10) == parseInt(this.model.get('sender_duid'), 10)) {
            this.user = GP.sdata.MessagingUsers.get(this.model.get('other_duid'));
        } else {
            this.user = GP.sdata.MessagingUsers.get(this.model.get('sender_duid'));
        }
    },
    modelEvents: {
        'change' : 'model_changed'
    },
    templateHelpers: {
        selected: function() {
            return (this.thread.selected) ? 'selected' : '';
        },
        unread: function() {
            return (parseInt(this.thread.unread_total, 10)) ? 'unread' : '';
        },
        replied: function() {
            return ((GP.sdata.my_user.duid == this.thread.sender_duid) && !_.contains(this.thread.tag, 'ATTACHMENT'));
        },
        priority: function() {
            let css_class = '';
            if (_.contains(this.thread.tag, 'PRIORITY')) {
                css_class = 'priority';
            }
            if (_.contains(this.thread.tag, 'PRIORITY_GUARANTEE') && this.thread?.claimable === true) {
                css_class = 'priority-guarantee';
            }

            return css_class;
        },
        user_online: function() {
            return (this.user.online_status == 'ONLINE') ? '' : 'hide';
        },
        thread_preview: function() {
            if (this.thread && this.thread.message) {
                return this.thread.message;
            } else {
                return '';
            }
        },
        has_attachment: function() {
            return _.contains(this.thread.tag, 'ATTACHMENT');
        },
        has_premium_attachment: function() {
            return _.contains(this.thread.tag, 'PREMIUM_ATTACHMENT');
        },
        show_claim_notice: function() {
            return ((GP.sdata.my_user.duid != this.thread.sender_duid) && _.contains(this.thread.tag, 'PRIORITY_GUARANTEE') && this.thread?.claimable === true);
        },
        is_verified: function() {
            return (this.user.verified_pic === 'Y');
        }
    },
    open_thread: function(e) {
        // console.log('TL open_thread called');

        if (MoshPit.get_size() == 'mobile') {
            localStorage.setItem('right_drawer_scrolltop', window.scrollY);
        }

        // IE11 picks up this click and closes the thread we just opened... wtf
        e.stopPropagation();

        var thread_model = this.model,
            user_model   = this.user;

        var bb_models = {
            'thread': thread_model,
            'user':   user_model
        };
        // console.log('TL open_thread bb_models: ', bb_models);

        if (
            GP.sdata.my_user.membership == 'FREE' 
            && MoshPit.get_size() == 'mobile' 
            && this.model.get('other_duid') != 69
            && !_ai_chatbot_duids.includes(parseInt(this.model.get('other_duid'),10))
        ) {
            GP.vent.trigger('Page:billing_redirect');
        } else {

            // hand off to MessagePane handle_bronze event to check
            // if we can call create_thread or not
            if (GP.sdata.my_user.membership == 'BRONZE') {
                // console.log('TL open_thread BRONZE LOGIC PASSED... calling handle_bronze');

                user_model.thread_json()
                    .done(function(thread_json) {
                        // console.warn('TL open_thread thread_json: ', thread_json);

                        if (GP.Util.check_obj(thread_json)) {
                            GP.vent.trigger('MessagePane:send_message', user_model.get('duid'), thread_json);
                        }
                    })
                    .fail(function() {});


                return;
            }

            GP.vent.trigger('MessagePane.Thread:create_thread', bb_models);
        }
    },
    del_thread_toggle: function(e) {
        e.stopPropagation();
        if ($('#threads-list .delete-thread:checked').length === 0) {
            GP.vent.trigger('MessagePane.Inbox:hide_del_thread');
        } else {
            GP.vent.trigger('MessagePane.Inbox:show_del_thread');
        }
    },
    billing_redirect: function(e) {
        // IE11 picks up this click and closes the thread we just opened... wtf
        e.stopPropagation();
        GP.vent.trigger('Page:billing_redirect', {billing_header: 'msg_expire'});
    },
    model_changed: function() {
        this.render();
    },
    serializeData: function() {
        var serialized_data = {
            user:   ((typeof this.user != 'undefined') ? this.user.toJSON() : {}),
            thread: this.model.toJSON()
        };

        return serialized_data;
    },
    onRender: function() {
        // don't render threads for discreet profiles on bank sites
        var discreet = (typeof this.user != 'undefined') ? this.user.get('discreet_profile') : 'N';
        if (_bank_site && discreet == 'Y') {
            this.$el.hide();
            return;
        }

        this.$el.attr('id', 'thread_'+this.model.id);
        jQuery.timeago.settings.strings = GP.Util.configs.timeago;
        this.$el.find('.timeago').timeago();

        if (
            GP.sdata.my_user.membership == 'FREE' 
            && GP.sdata.my_user.gender == 'MAN' 
            && !_ai_chatbot_duids.includes(parseInt(this.model.get('other_duid'),10))
        ) {
            var expire = this.model.get('thread_expire');
            if (typeof expire != 'undefined') {
                expire = parseInt(expire, 10);
                if (!isNaN(expire)) {
                    var expire_text = '';
                    if (expire === 1) {
                        expire_text = js_lang.msg_expires_singular;
                    } else if (expire === 0) {
                        expire_text = js_lang.msg_expiring_soon;
                    } else {
                        expire_text = js_lang.msg_expires_plural.replace(/%COUNT%/, expire);
                    }
                    this.$el.find('.expire-msg').append(expire_text).addClass('shown');
                }
            } else {
                // hide threads with no thread_expire attr (except site support/master)
                var other_duid = parseInt(this.model.get('other_duid'), 10);
                var msg_id = this.model.get('msg_id');
                if (msg_id != 1 && (other_duid != 69 && other_duid != 80918084)) {
                    this.$el.hide();
                }
            }
        }
    },
    show_checkboxes: function() {
        this.$el.addClass('checkbox-shown');
    },
    hide_checkboxes: function() {
        this.$el.removeClass('checkbox-shown checkbox-read-shown checkbox-unread-shown');
        this.$el.find('.delete-thread').prop("checked", false);
    },
    show_checkboxes_unread: function() {
        if (this.$el.find('.inbox-thread-item').hasClass('unread')) {
            this.$el.addClass('checkbox-unread-shown');
            this.$el.find('.delete-thread').prop("checked", true);
        }
    },
    show_checkboxes_read: function() {
        if (!this.$el.find('.inbox-thread-item').hasClass('unread')) {
            this.$el.addClass('checkbox-read-shown');
            this.$el.find('.delete-thread').prop("checked", true);
        }
    },
    show_checkboxes_all: function() {
        this.$el.addClass('checkbox-shown');
        this.$el.find('.delete-thread').prop("checked", true);
    },
});


GP.views.ThreadsList = Backbone.Marionette.CollectionView.extend({
    id: 'threads-list',
    className: 'media-list',
    childView: GP.views.ThreadsListItem,
    emptyView: GP.views.NoResultsItemView,
    isEmpty: function(collection) {
        return (collection.length === 0) ? true : false;
    }
});

